var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSessionTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 .9a.6.6 0 00-.592.503L3.9 3v3l.008.097a.6.6 0 001.184 0L5.1 6V3l-.008-.097A.6.6 0 004.5 2.4zm3.806-.849l.843.855a.4.4 0 01-.004.566l-.285.28a.4.4 0 01-.566-.003l-.843-.855a.4.4 0 01.004-.566l.285-.28a.4.4 0 01.566.003zM5.6 0c.22 0 .4.18.4.4v.4a.4.4 0 01-.4.4H3.4A.4.4 0 013 .8V.4c0-.22.18-.4.4-.4h2.2z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSessionTimer);
export default __webpack_public_path__ + "static/media/ic_session_timer.5e668293.svg";
export { ForwardRef as ReactComponent };